// @flow
import { Overlay } from "../Overlay"
import * as React from "react"
import {
  Consumer,
  SearchBox,
  Highlight,
  Hits,
  AngoliaSearchContainer
} from "./"
import { css } from "react-emotion/macro"
import type { tState } from "./"

export type tAngoliaSearch = {
  className?: string,
  style?: {},
  toggler: (props: tState) => React.Node,
  children: (props: {
    CloseButton: (props: {
      className?: string,
      style?: {},
      children?: React.Node
    }) => React.Node,
    SearchBox: any,
    Highlight: any,
    Hits: any
  }) => React.Node
}

export type tAngoliaSearchState = {}

export class AngoliaSearch extends React.Component<
  tAngoliaSearch,
  tAngoliaSearchState
> {
  render() {
    return (
      <AngoliaSearchContainer>
        <Consumer>
          {({ setIsActive, isActive }) => (
            <React.Fragment>
              {this.props.toggler({ isActive, setIsActive })}
              <Overlay
                style={this.props.style ? this.props.style : {}}
                isActive={isActive}
                className={
                  css`` +
                  " search-overlay " +
                  (this.props.className ? this.props.className : "")
                }
              >
                {this.props.children({
                  CloseButton: ({
                    className,
                    style,
                    children
                  }: {
                    className?: string,
                    style?: {},
                    children?: React.Node
                  }) => (
                    <button
                      className={className ? className : ""}
                      style={style ? style : {}}
                      onClick={() => setIsActive(false)}
                    >
                      {children ? children : "Close"}
                    </button>
                  ),
                  SearchBox,
                  Hits,
                  Highlight
                })}
              </Overlay>
            </React.Fragment>
          )}
        </Consumer>
      </AngoliaSearchContainer>
    )
  }
}

/**
 * @example
 * <AngoliaSearch
 *   className={searchOverlay}
 *     toggler={({ setIsActive }) => (
 *       <button onClick={() => setIsActive(true)}>
 *         <SearchIcon />
 *       </button>
 *     )}
 *   >
 *     {({ CloseButton, SearchBox, Hits }) => (
 *       <Container>
 *         <CloseButton className="btn btn-orange" />
 *         <h2>Search</h2>
 *         <div className="search-container">
 *           <SearchBox />
 *           <Hits
 *             hitComponent={({ hit }) =>
 *               hit.title && hit.path ? (
 *                 <Link to={hit.path}>
 *                   <div className="title">{hit.title}</div>
 *                   <div className="meta">
 *                     {hit.meta &&
 *                       hit.meta.length > 0 &&
 *                       hit.meta.map((item, i) => (
 *                         <span key={i}>{item}</span>
 *                       ))}
 *                   </div>
 *                 </Link>
 *               ) : null
 *             }
 *           />
 *         </div>
 *         <div className="logo-wrapper">
 *           <img src={algoliaLogo} alt="Search by: Algolia" />
 *         </div>
 *       </Container>
 *     )}
 * </AngoliaSearch>
 */



// WEBPACK FOOTER //
// /opt/build/repo/src/components/AlgoliaSearch/AngoliaSearch.js